import { SignIn as SignInComponent } from "../../components/SignIn/SignIn"
export const SignIn = () => {
  return (
    <div>
      <SignInComponent />
    </div>
  )
}
